// mutations
const SCHOOLROUTES_NEWS_ALL = (state, schoolRoutesNews) => {
  if (schoolRoutesNews.code === 1) {
    state.schoolRoutesNews = schoolRoutesNews.data
    state.status = 'success'
  } else {
    alert(schoolRoutesNews.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_NEWS_FORM = (state, schoolRoutesNews) => {
  if (schoolRoutesNews.code === 1) {
    state.schoolRoutesNews = schoolRoutesNews.data
    state.status = 'success'
  } else {
    alert(schoolRoutesNews.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_NEWS_SHOW = (state, schoolRoutesNews) => {
  if (schoolRoutesNews.code === 1) {
    state.schoolRoutesNews = schoolRoutesNews.data
    state.status = 'success'
  } else {
    alert(schoolRoutesNews.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_NEWS_CREATE = (state, schoolRoutesNews) => {
  if (schoolRoutesNews.code === 1) {
    state.schoolRoutesNews = schoolRoutesNews.data
    state.status = 'success'
  } else {
    alert(schoolRoutesNews.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_NEWS_UPDATE = (state, schoolRoutesNews) => {
  if (schoolRoutesNews.code === 1) {
    state.schoolRoutesNews = schoolRoutesNews.data
    state.status = 'success'
  } else {
    alert(schoolRoutesNews.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_NEWS_DELETE = (state, schoolRoutesNews) => {
  if (schoolRoutesNews.code === 1) {
    state.schoolRoutesNews = schoolRoutesNews.data
    state.status = 'success'
  } else {
    alert(schoolRoutesNews.message)
    state.status = 'error'
  }
}

export default {
  SCHOOLROUTES_NEWS_ALL,
  SCHOOLROUTES_NEWS_FORM,
  SCHOOLROUTES_NEWS_SHOW,
  SCHOOLROUTES_NEWS_CREATE,
  SCHOOLROUTES_NEWS_UPDATE,
  SCHOOLROUTES_NEWS_DELETE
}



// WEBPACK FOOTER //
// ./src/store/modules/schoolroutes/news/mutations.js